var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28033 4.24897C4.98744 3.95607 4.51256 3.95607 4.21967 4.24897C3.92678 4.54186 3.92678 5.01673 4.21967 5.30963L6.93934 8.0293L4.21967 10.749C3.92678 11.0419 3.92678 11.5167 4.21967 11.8096C4.51256 12.1025 4.98744 12.1025 5.28033 11.8096L8 9.08996L10.7197 11.8096C11.0126 12.1025 11.4874 12.1025 11.7803 11.8096C12.0732 11.5167 12.0732 11.0419 11.7803 10.749L9.06066 8.0293L11.7803 5.30963C12.0732 5.01673 12.0732 4.54186 11.7803 4.24897C11.4874 3.95607 11.0126 3.95607 10.7197 4.24897L8 6.96864L5.28033 4.24897Z",
    fill: "#A4A6A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.d4515ef456d1c9c7d92c006667e36007.svg";
export { ForwardRef as ReactComponent };